var rootStyle;

var setStyle = function setStyle(obj) {
  var keys = Object.keys(obj);
  keys.forEach(function (key) {
    var value = obj[key];
    rootStyle.setProperty("--".concat(key), value);
  });
  return keys;
};

var cv = function cv(arg) {
  // Make this work server-side
  rootStyle = rootStyle || document.documentElement.style;

  if (typeof arg === 'string') {
    return "var(--".concat(arg, ")");
  }

  if (arg && typeof arg === 'object') {
    return setStyle(arg);
  }
};

Object.defineProperty(cv, 'style', {
  get: function get() {
    return rootStyle;
  }
});
module.exports = cv;